// Angular
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BasePathService } from '../../../../core/_services/BasePathService';

@Component({
	selector: 'kt-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {
	
//	_pathRef = "../";

	constructor(public basePath: BasePathService)
	{
		// let location = window.location;

		// this._pathRef = 	location.href.replace(this.router.url,'/')

	}

 }
